import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import TabPaneCard from "./TabPaneCard";
import TabPaneMobile from "./TabPaneMobile";

export default function TabPanes(props) {
  const {
    tabIndex,
    tabConfig,
    filters,
    itemData,
    destComponent,
    mobComponent,
    columnConfig,
    expandConfig,
    text,
    location,
    findExpanded,
    clicked,
    getPageTitle,
    exportDataUpdate
  } = props; 
  
  return (
    <Row>
      <Col lg={24} md={0} xs={0}>        
        <TabPaneCard
          getPageTitle={getPageTitle}    
          exportDataUpdate={exportDataUpdate}     
          clicked={clicked}          
          findExpanded={findExpanded}
          itemData={itemData}
          tabIndex={tabIndex}
          length={itemData && itemData.length}
          tabConfig={tabConfig}
          filters={filters}
          tabComponent={destComponent}
          columnConfig={columnConfig}
          expandConfig={expandConfig}
          text={text}
          accountType={props.accountType}
          activeKey={props.activeKey}
        />
      </Col>
      <Col lg={0} md={24} xs={24}>        
        <TabPaneMobile
          getPageTitle={getPageTitle}
          exportDataUpdate={exportDataUpdate}
          clicked={clicked}          
          location={location}
          tabIndex={tabIndex}
          itemData={itemData}
          length={itemData && itemData.length}
          tabConfig={tabConfig}
          tabComponent={mobComponent}
          columnConfig={columnConfig}
          expandConfig={expandConfig}
          text={text}
          accountType={props.accountType}
          activeKey={props.activeKey}
        />
      </Col>
    </Row>
  );
}

TabPanes.propTypes = {
  accountType: PropTypes.any,
  activeKey: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  clicked: PropTypes.func,
  columnConfig: PropTypes.any,
  destComponent: PropTypes.string,
  expandConfig: PropTypes.any,
  filters: PropTypes.any,
  findExpanded: PropTypes.any,
  getPageTitle: PropTypes.any,
  itemData: PropTypes.array,
  location: PropTypes.any,
  mobComponent: PropTypes.any,
  tabConfig: PropTypes.func,
  tabIndex: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  text: PropTypes.any
}
